import styled from "styled-components";

export const MarkupTheme = styled.div`
  a {
    /* color: ${({ theme }) => theme.brandColors.primary}; */
    color: var(--p-color-text-interactive);
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      color: ${({ theme }) => theme.brandColors.primary};
      text-decoration: none;
    }
  }
`;
